/**
 * Firestore implementation of RectificationRepository.
 * Path: rectifications/{id}
 */
import {
  collection,
  doc,
  getDoc,
  setDoc,
  deleteDoc,
  getDocs,
  query,
  where,
} from 'firebase/firestore';
import { db } from '../../../lib/firebase';
import type { Rectification, EntityId } from '../../../types';
import type { RectificationRepository } from '../types';

const COLLECTION = 'rectifications';

export const firestoreRectificationRepository: RectificationRepository = {
  async findById(id: EntityId): Promise<Rectification | null> {
    const snap = await getDoc(doc(db, COLLECTION, id));
    return snap.exists() ? (snap.data() as Rectification) : null;
  },

  async save(entity: Rectification): Promise<void> {
    await setDoc(doc(db, COLLECTION, entity.id), entity);
  },

  async delete(id: EntityId): Promise<void> {
    await deleteDoc(doc(db, COLLECTION, id));
  },

  async list(): Promise<Rectification[]> {
    const snap = await getDocs(collection(db, COLLECTION));
    return snap.docs.map((d) => d.data() as Rectification);
  },

  async findByOrder(orderId: EntityId): Promise<Rectification[]> {
    const q = query(collection(db, COLLECTION), where('orderId', '==', orderId));
    const snap = await getDocs(q);
    return snap.docs.map((d) => d.data() as Rectification);
  },
};
